// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__2A_Fa","active":"NavigationItem_active__1ZepE"};